import { SearchType } from '@aibees/elephant/types';
import { LabelType } from '@aibees/elephant/types/label';
import { notificationIconMap } from '@aibees/elephant/utils';
import { IconName } from '@aibees/shared/components';
import { useMemo } from 'react';

interface UseLabelEntityConfigParams {
  type: LabelType;
  searchType: SearchType;
}

export function useLabelEntityConfig({
  type,
  searchType,
}: UseLabelEntityConfigParams) {
  return useMemo(() => {
    const isLabel = type === LabelType.LABEL;
    const searchTypeTag =
      searchType === SearchType.People ? 'Contact' : 'Account';

    return {
      isLabel,
      entityName: isLabel ? 'Label' : 'List',
      manageTitleDialog: `Manage ${searchTypeTag} ${
        isLabel ? 'Labels' : 'Lists'
      }`,
      emptyTitle: `${searchTypeTag} ${isLabel ? 'Labels' : 'Lists'}`,
      icon: (isLabel ? 'label' : 'list') as IconName,
      createDialogType: isLabel ? LabelType.LABEL : LabelType.LIST,
      notificationIcon: isLabel
        ? notificationIconMap.Label
        : notificationIconMap.List,
    };
  }, [type, searchType]);
}
